
import { windowatch } from '../../../scripts/lib/windowatch';

export default class Loop {

  constructor ($el) {
    this.$el = $el;

    // collect items
    this.$video = $el.querySelector('.loop__video');

    // Only load the loop video if it's not yet initialized
    this.$video.src = this.$video.getAttribute('data-src');
  }
}
